const generateFileObject = async (link, filename, type) => {
  const response = await fetch(link);
  if (!response.ok) throw new Error(`Failed to fetch file: ${response.statusText}`);

  const blob = await response.blob();
  return new File([blob], filename, { type: type });
};

export default generateFileObject;
